export const PROMO_PAGE_TYPES = {
  TOURNAMENT: 'tournament',
  PROMOTION: 'promotion',
  PROMOTIONS: 'promotions'
} as const;

export const COLOR_SCHEME_PLUGS = {
  ACTIVE_THEME: '_activeTheme_',
  ACTIVE_COLOR_SCHEME: '_activeColorScheme_',
  SELECTED_COLOR_MODE: '_selectedColorMode_'
};

export const RESPONSE_TYPES = {
  SSR_SERVER_LOGIN: 'SSR_SERVER_LOGIN', // REQUEST PROCESSING INITIATED

  CPU_OVERLOAD: 'CPU_OVERLOAD', // RETURNED STUB
  NO_CONNECTION_TO_REDIS: 'NO_CONNECTION_TO_REDIS', // RETURNED STUB
  SITE_SETTINGS_NOT_FOUND_IN_CACHE: 'SITE_SETTINGS_NOT_FOUND_IN_CACHE', // RETURNED STUB
  PAGE_IS_INVALID: 'PAGE_IS_INVALID', // RETURNED STUB
  PAGE_NOT_IN_CACHE: 'PAGE_NOT_IN_CACHE', // RETURNED STUB PAGE NOT HAVE IN CACHE START LOAD INFORMATION,
  ERROR_ON_LOAD_PAGE_BATCH: 'ERROR_ON_LOAD_PAGE_BATCH', // RETURNED STUB
  ERROR_ON_LOAD_SITE_SETTINGS: 'ERROR_ON_LOAD_SITE_SETTINGS', // RETURNED STUB
  ERROR_ON_LOAD_TRANSLATIONS: 'ERROR_ON_LOAD_TRANSLATIONS', // RETURNED STUB
  ERROR_ON_LOAD_SOME_DATA_FROM_CMS: 'ERROR_ON_LOAD_SOME_DATA_FROM_CMS', // RETURNED STUB
  // GLOBAL ERRORS
  LANGUAGE_DEFINITION_ERROR: 'LANGUAGE_DEFINITION_ERROR', // RETURNED STUB
  PAGE_VALIDATION_ERROR: 'PAGE_VALIDATION_ERROR', // RETURNED STUB
  HANDLE_REQUEST_ERROR: 'HANDLE_REQUEST_ERROR', // RETURNED STUB
  // END GLOBAL ERRORS

  REDIRECT_WHEN_CUSTOM_LOBBY_PAGE: 'REDIRECT_WHEN_CUSTOM_LOBBY_PAGE', // REDIRECT
  REDIRECT_TO_PATH_WITHOUT_LANGUAGE: 'REDIRECT_TO_PATH_WITHOUT_LANGUAGE', // REDIRECT
  REDIRECT_TO_VALID_LANGUAGE: 'REDIRECT_TO_VALID_LANGUAGE', // REDIRECT

  STARTED_LOAD_INFORMATION: 'STARTED_LOAD_INFORMATION', // START PAGE LOADING

  FINISHED_LOAD_INFORMATION_FROM_CACHE: 'FINISHED_LOAD_INFORMATION_FROM_CACHE', // RETURNED VALID PAGE FROM CACHE

  GET_RESOURCE_FROM_CMS_ERROR: 'GET_RESOURCE_FROM_CMS_ERROR' // FAILED LOAD FROM CMS
};
